import { createTheme } from "@mui/material/styles";
import { colors, fontFamily } from "./palette";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: colors.accent, dark: colors.accentDark },
    background: { default: colors.bg, paper: colors.card },
    text: { primary: colors.textPrimary, secondary: colors.textSecondary },
    divider: colors.border,
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily,
  },
});

export default theme;
